import React from 'react';

export type IframeProps = {
  frameId: string;
  title: string;
  src: string;
  className: string;
  onFrameLoad(): void;
};

export const Iframe: React.FC<IframeProps> = ({
  frameId,
  title,
  src,
  className,
  onFrameLoad
}: IframeProps) => {
  return (
    <iframe
      id={frameId}
      className={className}
      title={title}
      key={src}
      src={src}
      onLoad={onFrameLoad}
      data-testid="embedded-iframe"
    />
  );
};
